var map = {
	"./Blue/0.png": 32922,
	"./Blue/1.png": 40220,
	"./Blue/10.png": 77863,
	"./Blue/11.png": 21938,
	"./Blue/12.png": 96483,
	"./Blue/13.png": 53441,
	"./Blue/14.png": 85837,
	"./Blue/15.png": 21875,
	"./Blue/16.png": 83703,
	"./Blue/17.png": 25152,
	"./Blue/18.png": 94448,
	"./Blue/19.png": 32774,
	"./Blue/2.png": 16156,
	"./Blue/20.png": 15465,
	"./Blue/21.png": 71188,
	"./Blue/22.png": 17352,
	"./Blue/23.png": 14075,
	"./Blue/24.png": 75443,
	"./Blue/25.png": 62860,
	"./Blue/26.png": 18627,
	"./Blue/27.png": 2518,
	"./Blue/28.png": 7382,
	"./Blue/29.png": 94787,
	"./Blue/3.png": 21354,
	"./Blue/30.png": 29940,
	"./Blue/31.png": 20571,
	"./Blue/32.png": 99109,
	"./Blue/33.png": 9008,
	"./Blue/34.png": 41440,
	"./Blue/35.png": 26407,
	"./Blue/36.png": 59139,
	"./Blue/37.png": 89480,
	"./Blue/38.png": 17192,
	"./Blue/39.png": 77023,
	"./Blue/4.png": 71927,
	"./Blue/40.png": 86279,
	"./Blue/5.png": 47276,
	"./Blue/6.png": 53665,
	"./Blue/7.png": 67414,
	"./Blue/8.png": 11411,
	"./Blue/9.png": 26088,
	"./Gray/0.png": 57077,
	"./Gray/1.png": 5399,
	"./Gray/10.png": 47164,
	"./Gray/11.png": 60024,
	"./Gray/12.png": 48145,
	"./Gray/13.png": 6776,
	"./Gray/14.png": 1556,
	"./Gray/15.png": 8328,
	"./Gray/16.png": 73562,
	"./Gray/17.png": 63147,
	"./Gray/18.png": 48370,
	"./Gray/19.png": 30468,
	"./Gray/2.png": 49075,
	"./Gray/20.png": 960,
	"./Gray/21.png": 72103,
	"./Gray/22.png": 26973,
	"./Gray/23.png": 54412,
	"./Gray/24.png": 19127,
	"./Gray/25.png": 91037,
	"./Gray/26.png": 65695,
	"./Gray/27.png": 1869,
	"./Gray/28.png": 54110,
	"./Gray/29.png": 59530,
	"./Gray/3.png": 50844,
	"./Gray/30.png": 85398,
	"./Gray/31.png": 38123,
	"./Gray/32.png": 76324,
	"./Gray/33.png": 58389,
	"./Gray/34.png": 52221,
	"./Gray/35.png": 49611,
	"./Gray/36.png": 66690,
	"./Gray/37.png": 27063,
	"./Gray/38.png": 65370,
	"./Gray/39.png": 48760,
	"./Gray/4.png": 54141,
	"./Gray/40.png": 78398,
	"./Gray/5.png": 69711,
	"./Gray/6.png": 73728,
	"./Gray/7.png": 99464,
	"./Gray/8.png": 70633,
	"./Gray/9.png": 13075,
	"./Green/0.png": 60782,
	"./Green/1.png": 50404,
	"./Green/10.png": 40429,
	"./Green/11.png": 70645,
	"./Green/12.png": 73179,
	"./Green/13.png": 9607,
	"./Green/14.png": 43619,
	"./Green/15.png": 14730,
	"./Green/16.png": 8045,
	"./Green/17.png": 41390,
	"./Green/18.png": 34711,
	"./Green/19.png": 33446,
	"./Green/2.png": 16128,
	"./Green/20.png": 47572,
	"./Green/21.png": 95560,
	"./Green/22.png": 74805,
	"./Green/23.png": 91945,
	"./Green/24.png": 43060,
	"./Green/25.png": 57940,
	"./Green/26.png": 69159,
	"./Green/27.png": 47891,
	"./Green/28.png": 65973,
	"./Green/29.png": 84021,
	"./Green/3.png": 34770,
	"./Green/30.png": 79999,
	"./Green/31.png": 5477,
	"./Green/32.png": 35667,
	"./Green/33.png": 56122,
	"./Green/34.png": 63238,
	"./Green/35.png": 40725,
	"./Green/36.png": 49508,
	"./Green/37.png": 39999,
	"./Green/38.png": 77311,
	"./Green/39.png": 17497,
	"./Green/4.png": 1063,
	"./Green/40.png": 81630,
	"./Green/5.png": 47662,
	"./Green/6.png": 41995,
	"./Green/7.png": 14787,
	"./Green/8.png": 10685,
	"./Green/9.png": 57847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63190;